// extracted by mini-css-extract-plugin
export default {"button":"mainButton_button__pa4iV"};